/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpSquare = createReactComponent("arrow-up-square", "IconArrowUpSquare", [
  ["path", { d: "M12 17l0 -14", key: "svg-0" }],
  ["path", { d: "M15 6l-3 -3l-3 3", key: "svg-1" }],
  ["path", { d: "M10 21v-4h4v4z", key: "svg-2" }]
]);

export { IconArrowUpSquare as default };
//# sourceMappingURL=IconArrowUpSquare.js.map
